import { gql } from '@apollo/client';

const GET_TEMPLATE_EMAIL = gql`
  query GetTemplateEmail($storeId: ID!, $type: String!) {
    getTemplateEmail(storeId: $storeId, type: $type) {
      ... on GetTemplateEmailSuccess {
        code
        templateEmail {
          id
          storeId
          type
          mode
          subject
          html
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const UPSERT_TEMPLATE_EMAIL = gql`
  mutation UpsertTemplateEmail(
    $storeId: ID!
    $templateEmail: TemplateEmailInput!
  ) {
    upsertTemplateEmail(storeId: $storeId, templateEmail: $templateEmail) {
      ... on UpsertTemplateEmailSuccess {
        code
        upsertedTemplateEmail {
          id
          storeId
          type
          mode
          subject
          html
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const GET_EMAILS_PREFERENCES = gql`
  query GetEmailsPreferences($storeId: ID!) {
    getEmailsPreferences(storeId: $storeId) {
      ... on GetEmailsPreferencesSuccess {
        code
        preferences {
          storeId
          senderName
          senderEmail
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const UPSERT_EMAILS_PREFERENCES = gql`
  mutation UpsertEmailsPreferences($preferences: EmailsPreferencesInput!) {
    upsertEmailsPreferences(preferences: $preferences) {
      ... on UpsertEmailsPreferencesSuccess {
        code
        preferences {
          storeId
          senderName
          senderEmail
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

export default {
  GET_TEMPLATE_EMAIL,
  UPSERT_TEMPLATE_EMAIL,
  GET_EMAILS_PREFERENCES,
  UPSERT_EMAILS_PREFERENCES,
};
